<template>
  <div class="TuanTeamList">
    <van-list v-model="loading" :finished="dataList.finished" finished-text="没有更多了" @load="Search">
      <ShowList :list="dataList.list" :dataCheckList="dataCheckList" :form="ActiveShowForm"></ShowList>
    </van-list>
  </div>
</template>
<script>
import ShowList from '@/components/show/ShowList';
export default {
  name: 'TuanTeamList',
  components: { ShowList },
  data () {
    return {
      loading: false,
      Condition: {
        RoomList: [],
        ClassList: [],
        ClassTecList: [],
        LessonList: [],
        GrudeList: [],
        SubjectList: [],
        UserAllByIdList: []
      },
      dataList: {
        currentPage: 1,
        pageSize: 10,
        finished: false,
        list: [
          {
            headImgList: ['', ''],
            id: '12312312',
            joinId: '3123123123',
            restNum: 0
          },
          {
            headImgList: ['', ''],
            id: '12312312',
            joinId: '3123123123',
            restNum: 0
          }
        ],
        empty: 0
      },
      List: {},
      queryData: {
        Room: '', // 教室列表
        Class: '', // 班级列表
        ClassTec: '', // 老师列表
        Lesson: '', // 课程列表
        Grude: '', // 年级列表
        Subject: '', // 科目列表
        sysUserId: '' // 跟进人、经办人列表
      },
      ActiveShowForm: {
        // content: require('@/assets/images/common/banner.png'),
        name: '杭州教育艺术培训中心',
        title: '暑假班拼团，送福利！课程拼团仅需100元，大福利就来了',
        endTime: '2019-06-20',
        className: '',
        classDesc: '',
        classImg: [],
        originPrice: '688',
        groupPrice: '100',
        teamNum: '3',
        topNum: '20',
        activeDesc: '',
        rewardDesc: '',
        QrImg: [],
        ruleText: '',
        ruleImg: [],
        ruleVideo: [],
        phone: '',
        regList: [1, 2],
        eventName: '团购抢好课'
      },
      dataCheckList: [
        { name: '姓名', id: 1, content: '', requiredId: 1 },
        { name: '手机号', id: 2, content: '', requiredId: 2 }
      ]
    };
  },
  watch: {},
  computed: {},
  created () { },
  mounted () {
    // this.getList();
    if (this.$route.query.id) {
      this.getActiveShowForm();
    }
    // this.Search();
  },
  methods: {
    // getList (query) {
    //   if (query) this.queryData = { ...this.queryData, ...query };
    //   this.dataList.currentPage = 1;
    //   this.dataList.empty = 0;
    //   this.dataList.finished = false;
    //   this.Search();
    // },
    async Search () {
      try {
        this.loading = true;
        if (this.dataList.finished) {
          return;
        }
        let json = {
          current: this.dataList.currentPage,
          size: this.dataList.pageSize
        };
        let result = await this.$store.dispatch('postData', {
          url: '/activity/activity/teamList',
          data: { ...this.$route.query, ...json }
        });
        if (this.dataList.currentPage === 1) this.dataList.list = result.List;
        else this.dataList.list = [...this.dataList.list, ...result.List];
        this.$nextTick(() => {
          if (this.dataList.currentPage === 1 && result.List.length === 0) {
            this.dataList.empty = 10;
            this.dataList.finished = true;
          }
          this.dataList.finished =
            this.dataList.list.length >= result.TotalCount;
          this.dataList.currentPage++;
          this.loading = false;
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.dataList.finished = true;
        this.$error(e.message);
      }
    },
    async getInfo () {
      try {
        this.$loading();
        let json = {};
        let res = await this.$store.dispatch('postData', {
          url: '/api/booking/GetServiceCenterBySysNo',
          data: { Extra: json }
        });
        this.List = res;
        this.$loadingClose();
      } catch (e) {
        this.$error(e.message);
      }
    },
    async getActiveShowForm () {
      try {
        let json = {
          current: this.dataList.currentPage,
          size: this.dataList.pageSize
        };
        let result = await this.$store.dispatch('postData', {
          url: "/activity/activity/userActivityGet",
          data: { id: this.$route.query.id, ...json }
        });
        console.log(result, 'asad');
        // let baseList = result.requiredList
        //   // 去掉所有的必填
        //   .filter(it => {
        //     return !(it.id === '1' || it.id === '2');
        //   })
        //   .map(it => {
        //     return {
        //       ...it,
        //       content: '',
        //       requiredId: it.id
        //     };
        //   });
        // this.dataCheckList = [...this.dataCheckList, ...baseList];
        // this.ActiveShowForm = result.List;
        this.ActiveShowForm = {
          ...result.data,
          originalPrice: result.data.originalPrice / 100,
          price: result.data.price / 100,
          endTimeStemp:
            this.toTimeStamp(result.data.endTime) - new Date().getTime(),
          timeStr:
            this.dateFormat(
              this.toTimeStamp(result.data.startTime),
              "yyyy年MM月dd日"
            ) +
            "-" +
            this.dateFormat(this.toTimeStamp(result.data.endTime), "MM月dd日"),
          dateNum: Math.round(
            (this.toTimeStamp(result.data.endTime) -
              this.toTimeStamp(result.data.startTime)) /
            86400000
          ),
          imgsArr: result.data.imgs.split(",")
        };
      } catch (e) {
        this.$error(e.message);
      }
    }
  }
};
</script>
<style lang="less" scoped>
// .TuanTeamList {
// }
</style>
